import Vue from 'vue'

if (document.querySelector('#contains-date-format')) {

    Vue.config.productionTip = false

    const DateFormat = () => import(/* webpackChunkName: "assets/date-format" */ 'FrontComponents/vue/Date/DateFormat.vue')
    new Vue({
        el: '#contains-date-format',
        components: {
            DateFormat
        },
    })
}

